<script>

    import { toast } from 'bulma-toast'
    import { notificationStore, notificationsStore, modalStore } from '../stores'
    
    import NotificationsService from '../$services/notifications.service.js'

    import Form from '../$components/form.svelte'
    import InputText from '../$components/input.text.svelte'

    import Switch from '../$components/switch.svelte'
    import Date from '../$components/date.svelte'

    import ButtonModal from '../$components/button.modal.svelte'
    import ButtonSave from '../$components/button.save.svelte'

    const data = new Object({
        _id: $notificationStore._id,
        subject: $notificationStore.subject,
        message: $notificationStore.message,
        important: $notificationStore.important,
        expired: $notificationStore.expired
    })
    
    let loading = false

    async function updateNotification() {

        loading = true
        const resp = await NotificationsService.updateNotification(data._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        notificationsStore.replace(data._id, resp.data)
        notificationStore.set(resp.data)

        toast({message: 'Notificación actualizada', type: 'is-success'})

        modalStore.set('notification_modal')
    }

</script>

<Form on:submit={ updateNotification } { loading } >
    <div class="columns">
        <div class="column">
            <InputText bind:value={ data.subject } label="Tema" placeholder="Tema" />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputText bind:value={ data.message } label="Mensaje" placeholder="Mensaje" />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <Switch bind:checked={data.important} label="¿Notificación urgente?" />
        </div>
    </div>

    <Date bind:value={data.expired} label="Fecha de expiración" />

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <ButtonModal modalId="notification_modal" icon="ban" text="Cancelar" />
        <ButtonSave icon="edit" text="Actualizar" { loading } />
    </div>

</Form>